<template>
  <div
    class="item box-border flex flex-col flex-shrink-0 justify-end rounded-4xl overflow-hidden bg-gray-200 bg-center bg-cover relative z-1 cursor-pointer outline-solid-2"
    :class="{
      'w-35 h-45': size === 'sm',
      'w-65 h-85': size === 'md',
      'w-full h-100': size === 'lg',
      'p-6': ['md', 'lg'].includes(size),
      'px-4 py-5': size === 'sm',
      'outline-solid-purple-500': selected,
    }"
    :style="{
      'background-image': `url(${image})`,
      color: textColor
    }"
    @click="$emit('click')"
  >
    <div
      class="absolute -z-1 w-full left-0 bottom-0 pointer-events-none"
      :class="{
        'h-21': size === 'sm',
        'h-46': size === 'md',
        'h-52': size === 'lg',
      }"
      :style="{
        'background': `linear-gradient(to bottom, ${gradient.from}, ${gradient.to})`
      }"
    />

    <div v-if="isEditMode" class="handle absolute top-4 left-4">
      <div
        class="w-6 h-6 flex items-center justify-center rounded-md bg-opacity-40"
        :class="{
          'bg-black text-white': Boolean(image),
          'bg-white text-black': !Boolean(image),
        }"
      >
        <Icon icon="ph:dots-six-vertical-bold" height="16" />
      </div>
    </div>

    <div v-if="isEditMode" class="absolute top-4 right-4" @click.stop="$emit('delete')">
      <div
        class="w-6 h-6 flex items-center justify-center rounded-md bg-opacity-40"
        :class="{
          'bg-black text-white': Boolean(image),
          'bg-white text-black': !Boolean(image),
        }"
      >
        <Icon icon="ph:trash" height="16" />
      </div>
    </div>

    <h3
      class="font-bold m-0 whitespace-pre-line"
      :class="{
        'text-sm': size === 'sm',
        'text-3xl': size === 'md',
        'text-4xl': size === 'lg',
      }"
    >
      {{ title }}
    </h3>

    <p v-if="size !== 'sm'" class="text-base font-medium whitespace-pre-line m-0 mt-2">
      {{ description }}
    </p>
  </div>
</template>

<script>
import { useMode } from '../composables/mode'

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: 'md',
      validator: (size) => ['lg', 'md', 'sm'].includes(size)
    },
    image: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: '#FFFFFF'
    },
    gradient: {
      type: Object,
      default: () => ({
        from: 'transparent',
        to: '#323232',
      })
    },
    mode: {
      type: String,
      default: 'view',
      validator: (val) => ['view', 'edit'].includes(val)
    },
    selected: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { isEditMode } = useMode(props)

    return {
      isEditMode
    }
  }
}
</script>